import { NgModule } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { SVG_ICONS_DICTIONARY } from "./svg-icons-dictionary";
@NgModule({
  declarations: [],
  imports: [],
  exports: [],
})
export class IconsModule {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    Object.entries(SVG_ICONS_DICTIONARY).forEach(([iconName, svgContent]) => {
      this.matIconRegistry.addSvgIconLiteral(iconName, this.domSanitizer.bypassSecurityTrustHtml(svgContent));
    });
  }
}
